<template>
  <div class="not-found page">
    <h1>404</h1>
    <h2>Page not found</h2>
    <div class="smile">(>_<)</div>
  </div>
</template>

<script>
  export default {
    name: 'NotFound'
  }
</script>
<style lang="scss">
  .not-found.page {
    font-size: 50px;
    text-align: center;
    padding: 50px;
    .smile {
      padding-top: 20px;
      font-size: 100px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/NotFound.vue